/* eslint-disable no-use-before-define */
/* global PLATFORM, G */
import { curry, type PlatformEvent } from 'lib/util'
import session from 'app/_shared/session'
import find from 'lib/sequence/component/children/find'
import { get, set } from 'lib/sequence/component/state/value'
import { show } from 'lib/sequence/component/state/hidden'

interface Message {
  data: any
  value: any
  // TODO: Needs person model type
  refs: any
}

/**
 * Determines the desired partner of the last message
 * based on the submitter and sets the assignee
 * (partner) of the request to it.
 *
 * The logic is: The partner of "other side" is
 * relevant.
 * - Am I submitter (source) ? Take targetPartner
 * - Am I recipient (target) ? Take sourcePartner
 *
 * @param messages
 * @param module      the current module composition object
 * @param component   the current action's main component
 * @param event       the event object that triggered this handler
 * @returns           the messages with set partner
 */
const setPartner = async (
  messages: {data: Message[] },
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent,
) => {
  const { user } = (session(module) as { user: any })
  const { assigneeBox } = find(module[G.STATE][G.ACTION][G.COMPONENT])
  const { name } = find(assigneeBox)

  if (name && !get(name)) {
    const data = messages?.data || messages
    const submitter = data[0]?.refs.submitter?.[0]
    const relevantObject = user.key() !== (submitter?.key || submitter)
      ? 'sourcePartner'
      : 'targetPartner'
    const partner = data[0]?.value[relevantObject] || '-'

    set(name, partner)
    show(assigneeBox)

    // @ts-ignore
    PLATFORM === 'web' && module[G.ADAPTER][G.UI].update(module)
  }

  return messages
}

export default curry(setPartner)
